<!--
 Компонент отзывов
 @versions: all
 props:
  review - id ключа отзыва из переменной ReviewsList
  theme - тема шаблона темпная или светлая
-->

<template>
  <div
    :key="review"
    class="review"
    :class="[theme]"
  >
    <div class="review__top-block">
      <div class="review__rating">
        <nuxt-icon
          v-for="rating of ratingCount"
          :key="rating"
          name="rating-trust"
          filled
        />
      </div>
      <span class="review-name paragraph-12-500">
        {{ reviewItem.name }}
      </span>
    </div>
    <h3 class="review__title paragraph_14-700">
      {{ $t(reviewItem.title) }}
    </h3>
    <p class="review__text paragraph-12-500">
      {{ $t(reviewItem.text) }}
    </p>
  </div>
</template>

<script setup lang="ts">
import type { IReview } from '@quiz/models/IReview';

const { reviewsList } = useAppConfig().reviewsConfigs;
const { $logger } = useNuxtApp();

interface Props {
  review: number
  theme: 'light' | 'dark'
}

const props = defineProps<Props>();

const ratingCount = computed((): number => {
  const count = reviewItem.value.rating;
  return count > 0 ? count : 1;
});

const reviewItem = computed((): IReview => {
  if (!reviewsList[props.review]) {
    $logger.error(new Error(`Review ${props.review} is missing from reviewsList`), {
      tags: { flow: 'content', step: 'review_lookup' },
    });
    return reviewsList[7];
  }

  return reviewsList[props.review];
});
</script>

<style lang="scss" scoped>
.review {
  padding: 16px;
  margin-top: 8px;
  border-radius: 9px;

  &.light {
    background: $white;
    box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.15);

    & .review__title {
      color: $text-color;
    }

    & .review__text {
      font-weight: 400;
    }
  }

  &.dark {
    background: #1D1D1F;

    & .review__title {
      color: $white;
      margin-bottom: 8px;
    }

    & .review-name {
      color: $white;
      font-size: 12px;
      opacity: 0.5;
      margin-top: 1px;
    }

    & .review__text {
      color: $white;
      font-weight: 400;
    }
  }

  &__rating {
    display: flex;
    align-items: center;
    gap: 2px;
  }

  &__title {
    margin-bottom: 4px;
  }

  &__top-block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .review-name {
      font-size: 12px;
      opacity: 0.5;
    }
  }
}
</style>
